<template>
  <section class="container">

    <div class="content" style="margin-top:30px;">
      <component :is="currentView" v-bind:contact="contact" @step="inquiryForm"></component>
    </div>

  </section>
</template>

<script>
import Form from './components/Form.vue'
import Confirm from './components/Confirm.vue'
import Result from './components/Result.vue'


export default {
  components: {
    Form, Confirm, Result
  },


  data() {
    return {
      currentView: 'Form',

      token: '',
      apiUrl: 'https://www.jaea.go.jp/news/event/scienceagora/2020/api.php',
      //apiUrl: 'http://prd-check.hq.jaea.go.jp/news/event/scienceagora/2020/api.php',

      contact: {
        message: "フォームにご感想、ご質問等をご記入いただき「入力内容の確認」ボタンを押してください。",
        errors: [],


        name: '',
        email: '',
        age: '',
        gender: 0,
        content: '',


        /*
        name: 'いしかわ',
        email: 'ishikawa.yuya@jaea.go.jp',
        age: 37,
        gender: 0,
        content: 'て\nす\nと',
        */

        genders: ['未選択', '男性', '女性'],
      },

    }
  },


  methods: {


    inquiryForm (step) {

      if(step != 1){
        this.dataCheck()
      }

      if( Object.keys(this.contact.errors).length == 0 && step == 3) {
        //this.contact.message = "ご感想、ご質問を受け付けました。ありがとうございました。"
        this.token = document.getElementById('token').value

        let params = new URLSearchParams();
        params.append('name', this.contact.name);
        params.append('email', this.contact.email);
        params.append('age', this.contact.age);
        params.append('gender', this.contact.gender);
        params.append('content', this.contact.content);
        params.append('token', this.token);

        this.axios.post(this.apiUrl, params)
        .then(response => this.contact.message = response.data)
        .catch(error => this.contact.message = "Error : "+error.data);


        this.contact.name = ""
        this.contact.email = ""
        this.contact.age = ""
        this.contact.gender = 0
        this.contact.content = ""


        this.currentView = "Result"

      }else if( Object.keys(this.contact.errors).length == 0 && step == 2) {

        this.contact.message = "記入内容をご確認いただき「送信」ボタンを押してください。"
        this.currentView = "Confirm"

      }else{

        this.contact.message = "フォームにご感想、ご質問等をご記入いただき「入力内容の確認」ボタンを押してください。"
        this.currentView = "Form"

      }

    },


    dataCheck() {

      this.contact.errors = {};


      if (!this.contact.name) {
        this.contact.errors.name = '「お名前」を入力してください。';
      }


      if (!this.contact.email) {
        this.contact.errors.email = '「Eメールアドレス」を入力してください。';
      }else if (this.contact.email && !this.validEmail(this.contact.email)) {
        this.contact.errors.email = '正しい「Eメールアドレス」を入力してください。';
      }


      if ( ( this.contact.age && !this.validNumber(this.contact.age) ) || ( this.contact.age && (this.contact.age < 0 || this.contact.age > 200)) ) {
        this.contact.errors.age = '正しい「年齢」を入力してください。';
      }


      if ( typeof this.contact.genders[this.contact.gender] === 'undefined' ) {
        this.contact.errors.gender = '「性別」を選択してください。';
      }


      if (!this.contact.content) {
        this.contact.errors.content = '「ご感想、ご質問内容」を入力してください。';
      }


    },


    validNumber: function (num) {
      var re = /^[+-]?\d+$/;
      return re.test(num);
    },


    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }


  }
}
</script>

<style src="./assets/tailwind.css">
